import { animated, useSpring } from "@react-spring/web"
import classNames from "classnames"
import React from "react"
import ReactDom from "react-dom"

import "./style.css"

const Modal: React.FC<{
    visible: boolean
    children: React.ReactNode
    mask?: boolean
    width?: number | string
    className?: string
    wrapperClassName?: string
    onClose?(): void
}> = ({ visible, onClose, width = 480, children, mask = true, className, wrapperClassName }) => {
    const [portal, setPortal] = React.useState<any | null>(null)
    const [fade, setFade] = React.useState<boolean>()

    React.useEffect(() => {
        if (visible) {
            setFade(visible)
        } else {
            if (document.body.getElementsByClassName("reelpay_modal").length === 0) {
                document.body.style.overflow = "initial"
            }
        }
    }, [visible])

    const hideModal = () => {
        setFade(false)
    }

    React.useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape" && mask) {
                hideModal()
            }
        }

        const { overflow } = window.getComputedStyle(document.body)

        window.addEventListener("keydown", handleKeyDown, false)

        return () => {
            document.body.style.overflow = overflow
            window.removeEventListener("keydown", handleKeyDown, false)
        }
    }, [])

    const [fadeStyle, api] = useSpring(() => ({
        background: "rgba(0, 0, 0, 0)",
        backdropFilter: "blur(0px)",
        config: {
            duration: 150
        },
        fontFamily: "mono"
    }))

    React.useEffect(() => {
        if (fade !== void 0) {
            api.start({
                background: "rgba(0, 0, 0, .3)",
                backdropFilter: `blur(${fade ? 2 : 0}px)`
            })
            if (fade) {
                document.body.style.overflow = "hidden"
            }
            else {
                setTimeout(() => {
                    onClose?.()
                    setFade(void 0)
                }, 150)
            }
        }
    }, [fade])

    React.useEffect(() => {
        setPortal(document.querySelector("body"))
    }, [])

    return portal ? visible ? ReactDom.createPortal(
        <animated.div
            id="reelpay-modal-shadow"
            className="reelpay-modal-shadow"
            style={fadeStyle}
            onClick={mask ? hideModal : void 0}
        >
            <div
                style={{ width }}
                className={classNames("reelpay-modal", wrapperClassName, {
                    "cardFadeIn": fade !== void 0 && fade,
                    "cardFadeOut": fade !== void 0 && !fade
                })}
            >
                <div className={classNames("reelpay-modal-content", className)}>
                    {onClose && (
                        <svg className="reelpay-close" onClick={onClose} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 6L18 18" stroke="black" strokeWidth="2" />
                            <path d="M6 18L18 6" stroke="black" strokeWidth="2" />
                        </svg>
                    )}
                    {children}
                </div>
            </div>
        </animated.div>,
        portal
    ) : null : null
}

export default Modal
